import React from 'react'
import { useTranslation } from 'react-i18next'
import messageUtil from 'utils/messageUtil'
import CrosstabDisplayTypeDetail from 'enums/CrosstabDisplayTypeDetail'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import BarChart, { BarSelection } from 'components/visualization/Bar'
import { CrosstabWidgetsType, CrosstabData } from '../../types'
import { getWidgetSettingConfig } from '../utils/crosstabDataUtils'
import { tooltipValueFormatter, getBarColumnSetting, getXAxisNames, getTotalType } from './utils'

const BarDisplay = ({
  type,
  widgetId,
  crosstabData,
  onClick
}: {
  type: 'bar' | 'column'
  widgetId: number
  crosstabData: CrosstabData
  onClick: ({ category, seriesName, x, y, custom }: BarSelection, event: any) => void
}) => {
  const widgetSetting = useDashboardWidgetSetting<CrosstabWidgetsType>(widgetId)
  const { t } = useTranslation()

  const totalType = getTotalType(widgetSetting)
  const { displayValue, displayRowGrandTotal } = getWidgetSettingConfig(widgetSetting)
  const {
    crossTabs,
    rowIds,
    rowNames,
    columnIds,
    columnNames,
    rowComparisonMode,
    colComparisonMode
  } = crosstabData
  const { barSeriesData, barRowNames, barColNames } = getBarColumnSetting(
    crossTabs,
    widgetSetting,
    rowIds.map((rowId) => rowId.toString()),
    rowNames,
    columnIds.map((columnId) => columnId.toString()),
    columnNames,
    rowComparisonMode!,
    colComparisonMode!
  )
  const seriesHeader =
    totalType === CrosstabDisplayTypeDetail.ROWS
      ? messageUtil.comparisonModeOption(rowComparisonMode!)
      : messageUtil.comparisonModeOption(colComparisonMode!) || t('metric')
  return (
    <BarChart
      type={type}
      stacking={displayValue || displayRowGrandTotal ? 'value' : 'percent'}
      yAxisTitle={messageUtil.viewOption(widgetSetting.viewOption!)}
      xCategories={getXAxisNames(widgetSetting, barRowNames, barColNames)}
      seriesHeader={seriesHeader}
      showComparison
      yAxisLabelFormatter={displayRowGrandTotal ? (label: any) => `${label}%` : undefined}
      tooltipValueFormatter={displayRowGrandTotal ? tooltipValueFormatter : undefined}
      data={barSeriesData}
      xAxisLabelStyle="large"
      showGridLineY={type === 'column'}
      onClick={onClick}
    />
  )
}

export default BarDisplay
